/*
  isNoTVerify 是否越过token检测


*/

const visitorMode = Boolean(process.env.VUE_APP_VISITOR_MODE) // 游客模式

import request from '@/utils/request'

export function goodsList(data) {
	return request({
		url: 'goods/list',
		method: 'get',
		params: data,
		// isNoTVerify: visitorMode
	})
}

export function adinfo() {
	return request({
		url: 'ad/get-index',
		method: 'get',
		// isNoTVerify: visitorMode
	})
}

export function getCategory(data) {
	return request({
		url: 'category/list',
		method: 'get',
		params: data,
		// isNoTVerify: visitorMode
	})
}

export function getInfo(data) {
	return request({
		url: '/goods/info',
		method: 'get',
		params: data,
		// isNoTVerify: visitorMode
	})
}
